export const USERSNAP_GLOBAL_API_KEY = 'bcb54608-5ef3-4937-9e29-710486133b30';
